// import React, { useState } from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";


// export default function BookNowWithPopup() {
//   const [activeTab, setActiveTab] = useState("corporate");
//   const [showPopup, setShowPopup] = useState(false);

//   const openPopup = (type) => {
//     setActiveTab(type);
//     setShowPopup(true);
//   };

//   const closePopup = () => setShowPopup(false);

//   return (
//     <>
//       {/* ---------- MAIN BUTTONS (Corporate / Personal) ---------- */}
//       <div className="booknow-wrapper text-center">
//         <button
//           className={`tab-btn ${activeTab === "corporate" ? "active" : ""}`}
//           onClick={() => openPopup("corporate")}
//         >
//           CORPORATE
//         </button>

//         <button
//           className={`tab-btn ${activeTab === "personal" ? "active" : ""}`}
//           onClick={() => openPopup("personal")}
//         >
//           PERSONAL
//         </button>
//       </div>

//       {/* ---------- POPUP ---------- */}
//       {showPopup && (
//         <div className="popup-overlay">
//           <div className="popup-box">

//             {/* Close Button */}
//             <button className="close-btn" onClick={closePopup}>
//               <i className="fas fa-times"></i>
//             </button>

//             {/* Tab Switcher inside Popup */}
//             <div className="popup-tabs">
//               <button
//                 className={`tab-btn ${activeTab === "corporate" ? "active" : ""}`}
//                 onClick={() => setActiveTab("corporate")}
//               >
//                 CORPORATE
//               </button>

//               <button
//                 className={`tab-btn ${activeTab === "personal" ? "active" : ""}`}
//                 onClick={() => setActiveTab("personal")}
//               >
//                 PERSONAL
//               </button>
//             </div>

//             <h3 className="popup-title">
//               {activeTab === "corporate" ? "Corporate Booking" : "Personal Booking"}
//             </h3>

//             {/* ---------- FORM ---------- */}
//             <form className="booking-form">
//               <div className="row">

//                 <div className="col-md-6">
//                   <label>Full Name *</label>
//                   <input type="text" placeholder="Enter Full Name" />
//                 </div>

//                 <div className="col-md-6">
//                   <label>Contact Number *</label>
//                   <input type="text" placeholder="Enter Contact Number" />
//                 </div>

//                 <div className="col-md-6">
//                   <label>Email *</label>
//                   <input type="email" placeholder="Enter Email" />
//                 </div>

//                 <div className="col-md-6">
//                   <label>Select Car *</label>
//                   <select>
//                     <option>Sedan (4+1)</option>
//                     <option>SUV (6+1)</option>
//                     <option>Premium (4+1)</option>
//                     <option>Innova Crysta (6+1)</option>
//                   </select>
//                 </div>

//                 <div className="col-md-6">
//                   <label>Pick Up Location *</label>
//                   <input type="text" placeholder="Enter Pickup Location" />
//                 </div>

//                 <div className="col-md-6">
//                   <label>Where You Want to Go? *</label>
//                   <input type="text" placeholder="Enter Drop Location" />
//                 </div>

//                 <div className="col-md-6">
//                   <label>Pick Up Date *</label>
//                   <input type="date" />
//                 </div>

//                 <div className="col-md-6">
//                   <label>Pick Up Time *</label>
//                   <input type="time" />
//                 </div>

//                 {activeTab === "corporate" && (
//                   <>
//                     <div className="col-md-6">
//                       <label>Company Name *</label>
//                       <input type="text" placeholder="Enter Company Name" />
//                     </div>

//                     <div className="col-md-6">
//                       <label>Company Address *</label>
//                       <input type="text" placeholder="Enter Address" />
//                     </div>
//                   </>
//                 )}

//                 <div className="col-12">
//                   <label>Any Special Requirement *</label>
//                   <textarea placeholder="Your Message"></textarea>
//                 </div>

//               </div>

//               <button type="submit" className="submit-btn">
//                 <i className="fas fa-paper-plane"></i> Send
//               </button>
//             </form>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }









import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function BookNowWithPopup() {
  const [activeTab, setActiveTab] = useState("corporate");

  return (
    <div className="book-page-container">

      {/* ---------- TITLE TABS ---------- */}
      <div className="book-tabs">
        <button
          className={`tab-btn ${activeTab === "corporate" ? "active" : ""}`}
          onClick={() => setActiveTab("corporate")}
        >
          CORPORATE
        </button>

        <button
          className={`tab-btn ${activeTab === "personal" ? "active" : ""}`}
          onClick={() => setActiveTab("personal")}
        >
          PERSONAL
        </button>
      </div>

      <h2 className="form-title">
        {activeTab === "corporate" ? "Corporate Booking" : "Personal Booking"}
      </h2>

      {/* ---------- FULL FORM (NO POPUP) ---------- */}
      <form className="booking-form-full">

        <div className="row">

          <div className="col-md-6">
            <label>Full Name *</label>
            <input type="text" placeholder="Enter Full Name" />
          </div>

          <div className="col-md-6">
            <label>Contact Number *</label>
            <input type="text" placeholder="Enter Contact Number" />
          </div>

          <div className="col-md-6">
            <label>Email *</label>
            <input type="email" placeholder="Enter Email" />
          </div>

          <div className="col-md-6">
            <label>Select Car *</label>
            <select>
              <option>Sedan (4+1)</option>
              <option>SUV (6+1)</option>
              <option>Innova Crysta (6+1)</option>
              <option>Premium Sedan (4+1)</option>
            </select>
          </div>

          <div className="col-md-6">
            <label>Pick Up Location *</label>
            <input type="text" placeholder="Enter Pickup Location" />
          </div>

          <div className="col-md-6">
            <label>Drop Location *</label>
            <input type="text" placeholder="Enter Drop Location" />
          </div>

          <div className="col-md-6">
            <label>Pick Up Date *</label>
            <input type="date" />
          </div>

          <div className="col-md-6">
            <label>Pick Up Time *</label>
            <input type="time" />
          </div>

          {activeTab === "corporate" && (
            <>
              <div className="col-md-6">
                <label>Company Name *</label>
                <input type="text" placeholder="Enter Company Name" />
              </div>

              <div className="col-md-6">
                <label>Company Address *</label>
                <input type="text" placeholder="Enter Company Address" />
              </div>
            </>
          )}

          <div className="col-12">
            <label>Any Special Requirement *</label>
            <textarea placeholder="Your Message"></textarea>
          </div>
        </div>

        <button type="submit" className="send-btn">
          <i className="fas fa-paper-plane"></i> Submit Now
        </button>
      </form>
    </div>
  );
}
